import { useFlag } from '@unleash/proxy-client-react';

import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SyncAltIcon from '@mui/icons-material/SyncAltRounded';
import {
  Box, Button,
  Drawer,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationButton from '../../../Common/NotificationButton';
import SwContext from '../../Contexts/SwContext';
import useIsAppEnabled from '../../LiveContext/ApplicationSyncContext/useIsAppEnabled';
import useSessionContext from '../../LiveContext/SessionContextProvider/useSessionContext';
import AccountMenu from './Components/AccountMenu';
import ListeningIndicator from './Components/ListeningIndicator';
import ProjectButton from './Components/ProjectButton';
import SideMenu from './Components/SideMenu';
import StyledBox from './styles';

export default function Header() {
  const [openMenu, setOpenMenu] = React.useState<boolean>(false);
  const { session } = useSessionContext();
  const values = React.useContext(SwContext);
  const { t } = useTranslation();
  const flag = useFlag('webapp-notifications');
  const isAppEnabled = useIsAppEnabled();
  React.useEffect(() => {
    if (!session?.id && values?.needRefresh) {
      values?.refresh();
    }
  }, [session, values?.needRefresh]);

  return (
    <StyledBox>
      <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="left" keepMounted={false}>
        <SideMenu
          onClose={() => { setOpenMenu(false); }}
        />
      </Drawer>
      <Button onClick={() => { setOpenMenu(true); }}>
        <MenuRoundedIcon />
      </Button>
      <Box>
        <ProjectButton />
        {session?.id && <ListeningIndicator sessionId={session.id} />}
      </Box>
      <Box>
        {values?.needRefresh ? (
          <Button className="reload" onClick={() => { values?.refresh(); }}>
            {t('reload')}
          </Button>
        ) : <div />}
        {isAppEnabled && (
          <Button
            title={t('synced')}
            aria-label={t('synced')}
            onClick={() => { window.electronUiAPI?.uiShow('settings'); }}
          >
            <SyncAltIcon />
          </Button>
        )}
        {flag && (
          <NotificationButton />
        )}
        <AccountMenu />
      </Box>
    </StyledBox>
  );
}
